module.exports = __webpack_public_path__ + "images/757f4e069431cab5465a622ff40a8a72-IMG_6376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_6376.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_6376.jpg
// module chunks = 0